const initialState = {
  account: null,
  status: {
    isLoading: true
  }
}

const setLoading = (state, isLoading) => ({
  ...state,
  status: {
    isLoading
  }
})

const startLoading = (state) => setLoading(state, true)
const stopLoading = (state) => setLoading(state, false)

const accountLoaded = (state, {
  email
}) => ({
  ...state,
  status: {
    isLoading: false
  },
  account: {
    email
  }
})

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case 'GOOGLE_MEET_FETCH_ACCOUNT':
      return startLoading(state)
    case 'GOOGLE_MEET_FETCH_ACCOUNT_SUCCESS':
      return accountLoaded(state, payload)
    case 'GOOGLE_MEET_FETCH_ACCOUNT_COMPLETE':
      return stopLoading(state)
    default:
      return { ...initialState, ...state }
  }
}
